import React, { useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import {
    AUTH_ERROR_CODE_REQUIRES_RECENT_LOGIN,
    CANCEL,
    CONFIRM_DIALOG_BUTTON_LABEL_YES_DELETE_MY_ACCOUNT,
    CONFIRM_DIALOG_MESSAGE_DELETE_ACCOUNT_JS,
    CONFIRM_DIALOG_TITLE_DELETE_ACCOUNT_JS,
} from '../../common/constants';
import { deleteUserAccount } from '../../common/services/authServices';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdConfirmDialog from '../../common/elemental/AfitdConfirmDialog';
import AfitdLink from '../../common/elemental/AfitdLink';

//---------------------------------------------------------------------
// Utilities (lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import _toLower from 'lodash/toLower';

const useStyles = makeStyles(theme => ({
    heading: {
        fontWeight: 'bold',
        paddingBottom: 20,
    },
    deleteAccountLink: { textDecoration: 'underline' },
}));

const getDefns = params => {
    const { classes, handleClickDeleteAccountLink, confirmDeleteAccountDialogOpen, handleCloseConfirmDeleteAccountDialog, handleConfirmDeleteAccount } = params;

    const defns = {
        // LINK SECTION
        heading: { variant: 'h6', value: `My Account` },
        deleteAccountLink: { onClick: handleClickDeleteAccountLink },
        confirmDeleteAccountDialog: {
            title: CONFIRM_DIALOG_TITLE_DELETE_ACCOUNT_JS,
            onClose: handleCloseConfirmDeleteAccountDialog,
            onConfirm: handleConfirmDeleteAccount,
            open: confirmDeleteAccountDialogOpen,
            message: CONFIRM_DIALOG_MESSAGE_DELETE_ACCOUNT_JS,
            yesButtonLabel: CONFIRM_DIALOG_BUTTON_LABEL_YES_DELETE_MY_ACCOUNT,
            noButtonLabel: CANCEL,
            yesButtonLabelColor: 'red',
        },
    };

    // inject classes
    setClassNameInDefns(defns, classes);

    return defns;
};

const MyAccount = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const appContext = useContext(AppContext);
    const { setDeleteAccountSuccessfulMessageDialogOpen } = appContext;
    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;
    const classes = useStyles();

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [userName, setUserName] = useState('');
    // const [isDirty, setIsDirty] = useState(false);
    const [confirmDeleteAccountDialogOpen, setConfirmDeleteAccountDialogOpen] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // useEffect(() => {
    //     setUserName(currentUser?.userName || '');
    // }, [currentUser]);

    //---------------------------------------------------------------------
    // Event handlers
    //---------------------------------------------------------------------
    const handleClickDeleteAccountLink = evt => {
        // setError(null);
        // setIsDirty(true);
        // setUserName(evt.target.value);
        setConfirmDeleteAccountDialogOpen(true);
    };

    const handleCloseConfirmDeleteAccountDialog = () => {
        setConfirmDeleteAccountDialogOpen(false);
    };

    const handleConfirmDeleteAccount = async () => {
        try {
            await deleteUserAccount();
            // alert('Your account has been deleted successfully.');
            setDeleteAccountSuccessfulMessageDialogOpen(true);
        } catch (error) {
            if (error.message === AUTH_ERROR_CODE_REQUIRES_RECENT_LOGIN) alert('This action requires a more recent login.  Please log in again before retrying.');
            else alert('Unable to delete account. Please contact customer support at support@afootinthedoor.work.');
        }
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, handleClickDeleteAccountLink, confirmDeleteAccountDialogOpen, handleCloseConfirmDeleteAccountDialog, handleConfirmDeleteAccount });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div>
            {/* <AfitdRouterPrompt when={isDirty} /> */}
            <AfitdTypography {...defns.heading} />

            <AfitdLink label="Delete account" color="secondary" {...defns.deleteAccountLink} />
            {confirmDeleteAccountDialogOpen && <AfitdConfirmDialog {...defns.confirmDeleteAccountDialog} />}
        </div>
    );
};

export default MyAccount;
